import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {};

const enhance = compose();

const tableHead = enhance(({ order, orderBy, onRequestSort, roles }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        {(roles.isSecretariat || roles.isDeveloper) && <TableCell />}
        <TableCell sortDirection={orderBy === 'registeredAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'registeredAt'}
            direction={order}
            onClick={() => {
              onRequestSort('registeredAt');
            }}
          >
            申請日時
          </TableSortLabel>
        </TableCell>
        <TableCell>確認状況</TableCell>
        <TableCell>NG理由</TableCell>
        <TableCell>事務局メモ</TableCell>
        {(roles.isSecretariat || roles.isDeveloper) && (
          <TableCell>運営会社名</TableCell>
        )}
        <TableCell>店舗ID</TableCell>
        <TableCell>店舗名</TableCell>
        <TableCell>住所</TableCell>
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(tableHead);
